import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {};

export const mutations = {};

export const actions = {
  /**
   * 取得訂單列表
   * @param commit
   * @param category
   * @param type
   * @param startDate
   * @param endDate
   * @param city
   * @param brand
   * @param limit
   * @param page
   * @returns {Promise<AxiosResponse<any>>}
   */
  fetchOrderList({ commit }, {
    eventCategoryAlias,
    startDate,
    endDate,
    brandAlias,
    limit = 15,
    page = 1
  } = {}) {
    return request
      .post(`/member/orders`, {
        eventCategoryAlias,
        startDate,
        endDate,
        brandAlias,
        limit,
        page
      }, {
        ...configRequest,
        name: 'fetchOrderList'
      })
      .then((response) => {
        return {
          items: response.items,
          pagination: response.pagination
        }
      })
  },
  /**
   * 取得訂單項目
   * @param commit
   * @param eventAlias
   * @param seriesNum
   * @param showMessage
   * @returns {Promise<{items: *}>}
   */
  fetchOrderItem({ commit }, {
    eventAlias,
    seriesNum,
    showMessage = false
  } = {}) {
    return request
      .post(`/member/order`, {
        eventAlias,
        seriesNum,
      }, {
        ...configRequest,
        name: 'fetchOrderItem',
        showMessage
      })
      .then((response) => {
        return {
          items: response
        }
      })
  },

  /**
 * 取得訂單項目
 * @param commit
 * @param uuid
 * @param showMessage
 * @returns {Promise<{items: *}>}
 */
  fetchApplyOrderItem({ commit }, {
    uuid
  } = {}) {
    return request
      .get(`/member/order/${uuid}`, {
        ...configRequest,
        name: 'fetchOrderItem',
      })
      .then((response) => response.items)
  },

  /**
 * 取得報名場次項目
 * @param commit
 * @param uuid
 * @param showMessage
 * @returns {Promise<{items: *}>}
 */
  fetchOrderSessions({ commit }, {
    uuid
  } = {}) {
    return request
      .get(`/event/session/${uuid}`, {
        ...configRequest,
        name: 'fetchOrderSessions',
      })
      .then((response) => response.items)
  },

  /**
   * 取得報到場次
   * @param commit
   * @param uuid
   * @param showMessage
   * @returns {Promise<{items: *}>}
  */
  fetchOrderSessionsCheckin({ commit }, {
    uuid
  } = {}) {
    return request
      .get(`/event/session/${uuid}/checkin`, {
        ...configRequest,
        name: 'fetchOrderSessionsCheckin',
      })
      .then((response) => response.items)
  },

  /**
   * 取消已報名場次
   */
  cancelOrder({ commit }, {
    eventAlias,
    seriesNum,
    uuids,
  } = {}) {
    return request
      .post(`/member/order/cancel`, {
        eventAlias,
        seriesNum,
        uuids,
      }, {
        ...configRequest,
        name: 'CacelOrder'
      })
      .then((res) => {
        return {
          code: res.code,
          message: res.message,
          status: res.status,
        }
      })
  },
};

